import React, {useEffect, useMemo} from 'react';
import logo from './logo.svg';
import './App.css';
import Indexer from './pages/Indexer';
import wrapper from "./store/store";
import WalletProvider from './components/WalletProvider';
import { WalletStandardProvider } from '@wallet-standard/react';
import './i18n';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { ConnectionProvider, WalletProvider as SolanaWalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { Buffer } from 'buffer';
window.Buffer = Buffer;

function App() {
  const network = WalletAdapterNetwork.Mainnet; 
  const wallets = useMemo(() => 
    [new PhantomWalletAdapter(), new SolflareWalletAdapter()]
  ,[]
  );
  return (
    <WalletStandardProvider>
      <WalletProvider>
        <ConnectionProvider endpoint={process.env.REACT_APP_SOLANA_RPC_URL}>
          <SolanaWalletProvider wallets={wallets} autoConnect={false}>
            <Router>
              <Indexer />
            </Router>
          </SolanaWalletProvider>
        </ConnectionProvider>
      </WalletProvider>
    </WalletStandardProvider>
  );
}

export default App;
